import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';
import { observer } from 'mobx-react';

const DeliveryMethodsQuery = gql`
  query ($country: String) {
    deliveryMethods(where: { country: $country }) {
      id
      name
      description
      price
      deliveryTimeDays
      type
      priority
      active
      prices {
        currencyId
        priceWithout
        fromWeight
        toWeight
        active
      }
      pricesByWeight
      insurance
      insuranceLimits {
        prices {
          currencyId
          priceWithout
          recommendedPriceWithout
        }
        fromPriceOrder {
          currencyId
          priceWithout
          recommendedPriceWithout
        }
        toPriceOrder {
          currencyId
          priceWithout
          recommendedPriceWithout
        }
      }
      unknownPrice
      unknownPriceLabel
      paymentMethods {
        id
        name
        description
        tags
        price
        image
        gateway
        priority
        active
      }
      countries {
        id
      }
    }
    languages {
      id
      value
    }
  }
`;

interface IInputProps {
  children?: any;
  country?: string;
}

interface IResponse {
  data: any;
}

@observer
class GetDeliveryMethodsQuery extends React.Component<ChildProps<IInputProps, IResponse>, {}> {
  public render() {
    const { deliveryMethods, createDeliveryMethod, updateDeliveryMethod, deleteDeliveryMethod }: any = this.props;
    return this.props.children({
      deliveryMethods,
      createDeliveryMethod,
      updateDeliveryMethod,
      deleteDeliveryMethod
    });
  }
}

export default compose(
  graphql<IInputProps, IResponse>(DeliveryMethodsQuery, {
    name: 'deliveryMethods'
  })
)(GetDeliveryMethodsQuery);



// WEBPACK FOOTER //
// ./src/components/Query/DeliveryMethods/DeliveryMethods.tsx